import { createI18n } from 'vue-i18n'
import zh from './lang/zh'
import en from './lang/en'

// 创建 i18n 实例
export const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: localStorage.getItem('lang') || 'zh',
  fallbackLocale: 'zh',
  messages: {
    'zh': zh,
    'en': en
  },
  silentTranslationWarn: true
})

// 语言切换方法
export function setLocale(lang) {
  try {
    i18n.global.locale = lang
    localStorage.setItem('lang', lang)
    document.documentElement.lang = lang
  } catch (error) {
    console.error('切换语言失败:', error)
  }
}